<template>
    <div class="verify-print" id="pdfDom">
        <!--封面-->
        <div class="page" id="page_cover">
            <div class="page_padding">
                <div class="cover">
                    <div class="cover_title text-center">
                        <div>
                            <img src="../assets/img/verify_print/logo.png" width="60%">
                        </div>
                        <div class="mt-4">
                            <img src="../assets/img/verify_print/sub-title.png" width="40%">
                        </div>
                    </div>
                    <div class="cover_summary">
                        <table>
                            <tbody>
                                <tr>
                                    <th>匯出時間：</th>
                                    <td>{{this.printData.exportTime}}</td>
                                </tr>
                                <tr>
                                    <th>驗證時間：</th>
                                    <td>{{this.printData.verifyTime}}</td>
                                </tr>
                                <tr>
                                    <th>驗證人員：</th>
                                    <td v-if="this.printData.user">{{this.printData.user.name}}</td>
                                </tr>
                                <tr>
                                    <th>機關單位：</th>
                                    <td v-if="this.printData.user">{{this.printData.user.unit}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!--內容：驗證結果-->
        <div class="page" v-for="(result, index) in this.printData.results" :key="result.id" :id="'page_' + index">
            <div class="page_padding">
                <div class="page_title">
                    <img class="mr-2" src="../assets/img/verify_print/logo.png" width="200px">
                </div>
                <div class="main_contain">
                    <div class="info_box" v-for="data in result" :key="data.id">
                        <div class="info_box-result">
                            <div class="table_header bg-darkblue">驗證資訊</div>
                            <div class="table_body">
                                <div class="file_info">
                                    <table>
                                        <tr>
                                            <th>檔案名稱：</th>
                                            <td>{{data.fileName}}</td>
                                            <th>驗證結果：</th>
                                            <template v-if="data.result">
                                                <td class="verify_result"><img src="../assets/img/verify_print/icon_check.svg"><span class="bt bt_success">驗證成功</span></td>
                                            </template>
                                            <template v-else>
                                                <td class="verify_result"><img src="../assets/img/verify_print/icon_close.svg"><span class="bt bt_fail">驗證失敗</span></td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <th>檔案雜湊值：</th>
                                            <td class="ellipsis">{{data.hash}}</td>
                                            <th>驗證時間：</th>
                                            <td>{{printData.verifyTime}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <template v-if="data.result">
                            <div class="info_box-blockchain">
                                <div class="table_header bg-gold">區塊鏈資訊</div>
                                <div class="table_body">
                                    <div class="file_info">
                                        <table>
                                            <tr>
                                                <th>存證時間：</th>
                                                <td v-if="data.txMap">{{data.txMap.timestamp}}</td>
                                            </tr>
                                            <tr>
                                                <th>Channel 名稱：</th>
                                                <td>mojchannel-test</td>
                                                <th>Chaincode 名稱：</th>
                                                <td>example</td>
                                            </tr>
                                            <tr>
                                                <th>Transaction ID：</th>
                                                <td v-if="data.txMap">{{data.txMap.txid}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// import MobileDetect from 'mobile-detect'
// import { verifyReportToPdf } from '../utils/functions.js'

export default {
    name: "VerifyPrintPage",
    methods: {
        async fetchTxid(hash) {
            const res = await axios.get(`${process.env.VUE_APP_BACKEND_API_URL}/search?queryString=${hash}`);
            if (res.status == 200 && res.data) {
                return res.data[0].txid;
            }
            return '';
        }
    },
    data() {
        return {
            printData: {}
        }
    },
    async mounted() {
        if(process.env.VUE_APP_WEBSITE_AVAILABLE == 0){
            this.$router.push('/');
        }
        // let md = new MobileDetect(navigator.userAgent);
        // let pdfFilename = 'export';
        const sliceArray = (arr, size) => {
            var arr2 = [];
            for (var i = 0; i < arr.length; i = i + size) {
                arr2.push(arr.slice(i, i + size));
            }
            return arr2;
        }
        const fetchData = async () => {
            let reportData = JSON.parse(sessionStorage.getItem('reportData'));
            let userName = sessionStorage.getItem('username');
            let userOrg = sessionStorage.getItem('organs');
            reportData.results.forEach((element, index) => {
                if (element.txMap && element.txMap.timestamp) {
                    reportData.results[index].txMap.timestamp = moment.unix(Math.floor(reportData.results[index].txMap.timestamp / 1000)).format('YYYY/MM/DD HH:mm:ss');
                }
            })
            this.printData = {
                exportTime: moment.unix(Math.floor(Date.now() / 1000)).format('YYYY/MM/DD HH:mm:ss'),
                verifyTime: reportData.verifyTime,
                user: {
                    name: userName ? userName : '',
                    unit: userOrg ? userOrg : ''
                },
                results: sliceArray(reportData.results, 2)
            }
            // pdfFilename = 'export-' + this.printData.exportTime;
        }
        await fetchData()
        // if (!md.mobile()) {
        //     console.log(pdfFilename);
        //     verifyReportToPdf.getPdf(pdfFilename);
        // }
    }
};
</script>
<style src="../assets/style/verifyPrint.css" scoped></style>